import { css } from "styled-components";
import { CardImage, CardTitle, CardBody, CardDescription } from "../../../../components/Card";
export const riotProductSkin = (theme) => css `
  height: 100%;
  width: 100%;
  aspect-ratio: 16/9;
  place-items: center;
  display: grid;
  grid-template-columns: 3fr 1fr 3fr;
  grid-template-rows: 1fr 1fr 1fr;

  * {
    position: relative;
  }

  ${CardImage} {
    grid-column: 1 / span 3;
    grid-row: 1 / span 3;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .icon-link {
    position: absolute;
    top: 10px;
    right: 10px;
    ${theme.typography.display9};
  }

  .icon-action-play-video {
    transition: transform 0.2s ease-in-out;
    left: 0;
    top: 0;
    transform: translate(0%, 0%);
    grid-column: 2;
    grid-row: 2;
    position: relative;
    width: 100%;
    height: 100%;
    aspect-ratio: 1/1;
    max-width: 110px;
    max-height: 110px;
    min-width: 55px;
    min-height: 55px;
  }

  &:hover {
    .icon-action-play-video {
      transform: scale(1.15);
    }
  }

  ${CardBody} {
    width: 100%;
    padding: 0 14px 12px 14px;
    background: linear-gradient(0deg, rgb(0 0 0 / 75%), rgb(0 0 0 / 55%) 50%, transparent);
    place-self: end;
    grid-column: 1 / span 3;
    grid-row: 3;
    ${CardTitle} {
      ${theme.typography.display9};
      display: -webkit-box;
      color: white;
      text-shadow: 0 3px 3px rgb(0 0 0 / 50%);
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    ${CardDescription} {
      color: white;
    }
  }
`;
//# sourceMappingURL=index.js.map